import React, { useEffect } from 'react'
import { ServerConfig } from 'config'
import axios from 'axios'
import { useSelector } from 'react-redux'
// import Progress from 'react-circle-progress-bar'
import { makeStyles } from '@material-ui/core/styles'
import HoursManagement from './HoursManagement'

// @material-ui/core components
import { Typography, Modal, Button, Box, Grid } from '@material-ui/core'
import _, { get } from 'lodash'

import EditIcon from '@material-ui/icons/Edit';

import LedgerComponent from './LedgerComponent'
import {utc_timestamp_to_local_datetime_string, utc_timestamp_to_hours_ago_string} from "../../utils/datetime_utc_local";
import {ecosackState} from "../../utils/ecosackState";
import InfoBanner from '../common/InfoBanner'

const evt = new Event('customertable_is_dirty');


const useStyles = makeStyles((theme) => ({
  detailsBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: 'white',
    border: '1px solid #fff',
    borderRadius: '20px',
    padding: '20px',
    boxShadow: 24,
    //padding: 4,
  },
  breakFloat: {
    clear: 'both'
  },
  // minWidth instead of width so long labels don't wrap and break the float rows
  fieldLabel: {
    display: 'block',
    minWidth: '150px',
  },
}))


const DetailsEditComponent = (props) => {
  const classes = useStyles()
  const [details, setDetails] = React.useState({})
  const [tenantSites, setTenantSites] = React.useState([])
  const [operationtypes, setOperationtypes] = React.useState([])
  const [materials, setMaterials] = React.useState([])
  const [status, setStatus] = React.useState({
    kind: "idle",          // "idle" | "info" | "loading" | "success" | "error"
    message: "",
    dirty: { main: false, hours: false }
  });
  
  const auth = useSelector(state => state.auth)

  const hoursRef = React.useRef();

  const {
    rowData,
    detail_get_url,
    detail_put_url,
    detail_delete_url,
    onDeleted,
    view_request,
    details_enrichment,
    ledger_get_url,
    ledger_allow_entries,
    show_machine_stats,
    info_banner_items,
    editable_fields = [],
    non_editable_fields = [],
  } = props;

  useEffect(() => {
    const fetchDetails = () => {
      const config = { headers: { 'Content-Type': 'application/json' } }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      detail_get_url && axios.get(detail_get_url + rowData.id, config)
          .then((res) => {
            setDetails(res.data)
          }).catch((error) => {
            console.error('Error fetching details:', error);
          });

      view_request && axios.get(view_request(rowData), config)
          .then((res) => {
              const {data} = res;
              if (details_enrichment) {
                setDetails({...data, ...details_enrichment(data), id: data.id, ecocontrol_name: data.name });
              } else {
                setDetails(data);
              }
          }).catch((error) => {
            console.error('Error fetching details:', error);
          });
    };

  // get enum-values for select-field if needed
  const fetchOperationtypes = () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    axios.get(`${ServerConfig.SERVER_URL}/tenant/machines/operationtypes`, config)
        .then((res) => {
            setOperationtypes(res.data)
        })
  };

  // get enum-values for materials
  const fetchMaterialtypes = () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    axios.get(`${ServerConfig.SERVER_URL}/admin/materials`, config)
        .then((res)=> {
          setMaterials(res.data)
        })
  };

  const fetchTenantSites = () => {
    const config = {headers:{'Content-Type':'application/json'}}

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    axios.get(`${ServerConfig.SERVER_URL}/tenant/tenant_sites`, config)
        .then((res) => {
            setTenantSites(res.data)
        })
  };

    fetchMaterialtypes();
    fetchDetails();
    fetchOperationtypes();
    fetchTenantSites();
  }, [])


  // submit data and update object
  const handleSubmit = (event) => {
    event.preventDefault();

    const config = { headers: { 'Content-Type': 'application/json' } }
    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    const dirtyMain  = status?.dirty?.main && editable_fields.length > 0;
    const dirtyHours = status?.dirty?.hours && !!hoursRef.current;

    let updatePromises = [];
    let updateMessages = [];

    // show loading (preserve any existing dirty flags on status if you already added them)
    setStatus((s) => ({ ...s, kind: "loading", message: "Saving..." }));

    // Handle main form submission if there are changes
    if (dirtyMain) {
      const data = new FormData(event.target);
      const value = Object.fromEntries(data.entries());

      if (value.new_state !== undefined) {
          value.new_state = Number(value.new_state);
        }

      // do some postprocessing for values if needed
      editable_fields.map(function(fieldname, bla) {
        switch (fieldname[2]) {
          case "currency":
            value[fieldname[0]] = value[fieldname[0]] * 1e6  // dollar to microdollar
            break;
        }
      });

      updatePromises.push(
        axios.put(detail_put_url + details.id, value, config)
        .then(() => updateMessages.push("Site details updated"))
        .catch((error) => {
          console.error('Error updating site details:', error);
          const backendMessage = error.response?.data?.msg;
          updateMessages.push(backendMessage ? `Error updating site details: ${backendMessage}` : "Error updating site details");
        })
      );
    }

    // Handle hours submission if there are changes
    if (dirtyHours) {
      const hoursData = hoursRef.current.getHoursData();

      // Always POST all hours data (including services closed all week)
      updatePromises.push(
        axios.post(`${detail_put_url + details.id}/hours`, hoursData, config)
        .then(() => updateMessages.push("Hours updated"))
        .catch((error) => {
          console.error('Error updating hours:', error);
          updateMessages.push("Error updating hours");
        })
      );
    }

		// Execute all updates
    if (updatePromises.length > 0) {
      // NOTE: use allSettled so one failure doesn't cancel the rest
      Promise.allSettled(updatePromises)
        .then((results) => {
          const anyRejected = results.some((r) => r.status === "rejected");
          const finalMessage =
            updateMessages.join(", ") ||
            (anyRejected ? "Error updating some fields" : "Saved");

          // Reset change flags (unchanged behavior)
          if (hoursRef.current && typeof hoursRef.current.resetChanges === "function") {
            hoursRef.current.resetChanges();
          }

          // Unified status
          setStatus((s) => ({
            ...s,
            kind: anyRejected ? "error" : "success",
            message: finalMessage,
            // if you later add status.dirty, clear it safely
            dirty: s?.dirty ? { main: false, hours: false } : s?.dirty
          }));

          if (!anyRejected) {
            window.dispatchEvent(evt);
          }
        })
        .catch(() => {
          setStatus((s) => ({ ...s, kind: "error", message: "Error updating some fields" }));
        });
    } else {
      setStatus((s) => ({ ...s, kind: "info", message: "No changes to save" }));
    }
	};

  const handleDelete = () => {
    const config = { headers: { 'Content-Type': 'application/json' } }
    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    setStatus((s) => ({ ...s, kind: "loading", message: "Deleting..." }));

    axios.delete(detail_delete_url + details.id, config)
      .then(() => {
        window.dispatchEvent(evt);
        if (onDeleted) {
          onDeleted();
        }
      })
      .catch((error) => {
        setStatus((s) => ({
          ...s,
          kind: "error",
          message: error.response?.data?.msg || "Error deleting",
        }));
      });
  };

  // Handler for main form field changes
  const handleMainFormChange = (e) => {
    // update local state so controlled inputs can change
    if (e?.target) {
      const { name, type, checked, value } = e.target;
      setDetails((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }

    setStatus(s => ({
      ...s,
      kind: "info",
      message: "Unsaved changes",
      dirty: { ...s.dirty, main: true }
    }));
  };

    // Handler for hours changes
  const handleHoursChange = (hasChanges) => {
    setStatus(s => ({
      ...s,
      kind: hasChanges ? "info" : s.kind,
      message: hasChanges ? "Unsaved changes" : s.message,
      dirty: { ...s.dirty, hours: hasChanges }
    }));
  };

    const processChangelist = (fieldname) => {
        let changelist = details[fieldname];
        if(changelist !== undefined){
            changelist.map(function(change, bla){
                return {change}
            })
        }
    }

  return (
    <>
      {info_banner_items && info_banner_items.length > 0 &&
        <InfoBanner items={info_banner_items} style={{marginTop: '0', marginBottom: '20px' }} />
      }
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Details {details.id}
      </Typography>

      <hr />

      {
        non_editable_fields.map(function(fieldname, bla){
          const detailValue = get(details, fieldname[0]);
            switch (fieldname[2]) {
              case "date":
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="date" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} />
                </div>
              case "currency":
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue !== undefined && detailValue !== null ? "$" + (detailValue/ 1e6).toFixed(2) : ""} />
                </div>
              case "timestamp":
				        return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue ? utc_timestamp_to_local_datetime_string(detailValue) : ''}   />
                </div>
              case "weight":
              case "count":
                if(detailValue !== undefined && detailValue != 0){
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue}  />
                    </div>
                }
                break
              case "dont_show_if_empty":
                if(detailValue !== undefined){
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={detailValue}  />
                    </div>
                }
                break
              case "changelist":
                if(detailValue === undefined){
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value="No changes"  />
                    </div>
                }else if(detailValue.length === 0 ){
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value="No changes"  />
                    </div>
                }else{
                    return <div className="form-group" style={{'float': 'left', 'margin': '10px', 'width': '100%'}}>Changelist:<br/>
                        <table style={{}}>
                        <tr style={{}}><th>Type</th><th>Subject</th><th>Old val</th><th>&nbsp;</th><th>New val</th></tr>
                        {detailValue.map(function(change, bla){
                        if(change.new_value_count !== null){
                            if(change.old_value_count === null){
                                return <tr><td>[C]</td><td>{change.subject}</td><td></td><td>-{'>'}</td><td>{change.new_value_count}</td></tr>
                            }else{
                                return <tr><td>[C]</td><td>{change.subject}</td><td>{change.old_value_count}</td><td>-{'>'}</td><td>{change.new_value_count}</td></tr>
                            }

                        }else{
                            if(change.old_value_weight_lbs === null){
                                return <tr><td>[W]</td><td>{change.subject}</td><td></td><td>-{'>'}</td><td>{change.new_value_weight_lbs}lbs</td></tr>
                            }else{
                                return <tr><td>[W]</td><td>{change.subject}</td><td>{change.old_value_weight_lbs}lbs</td><td>-{'>'}</td><td>{change.new_value_weight_lbs}lbs</td></tr>
                            }

                        }
                        })}
                        </table></div>
                }
              case "b64image":
                if(detailValue !== undefined){
                  return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                    <img class="form-control" src={`${detailValue}`} style={{'width':'260px'}}/>
                    </div>
                }
                break
              case "ecosackState":
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={ecosackState(detailValue)}  />
                    </div>
              case "hours_ago":
                    return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} value={utc_timestamp_to_hours_ago_string(detailValue)}  />
                    </div>
              case "break":
                  return (
                  <>
                    <hr className={classes.breakFloat} />
                    {fieldname[1] && <Typography variant="h4" >{fieldname[1]}</Typography>}
                  </>
                )
              case "header":
                  return <Typography variant="h4" >{fieldname[1]}</Typography>
              default:
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input disabled type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue}  />
                </div>
            }
        })
      }

      <form onSubmit={handleSubmit}>
        {
          editable_fields.map(function (fieldname, bla) {
            const detailValue = get(details, fieldname[0]);
            switch (fieldname[2]) {
              case "date":
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input type="date" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange} />
                </div>
              case "boolean":
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px', 'width': '256px'}}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <input type="hidden" name={fieldname[0]} value={false} />
                    <div style={{'lineHeight':'38px', 'display': 'inlineBlock', 'verticalAlign':'middle'}}>
                        <input type="checkbox" class="custom-control-input" style={{'width':'20px', 'height':'20px', 'marginRight': '10px', 'verticalAlign': 'middle'}} name={fieldname[0]} id={fieldname[0]} value={true} checked={!!detailValue} onChange={handleMainFormChange} />{fieldname[1]}
                    </div>
                </div>
              case "currency":
                if (detailValue !== undefined){
                return <div className="form-group" style={{'float': 'left', 'margin': '10px'}}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input type="text" className="form-control" name={fieldname[0]} id={fieldname[0]}
                        defaultValue={detailValue !== undefined && detailValue !== null ? "$" + (detailValue/ 1e6).toFixed(2) : ""} onChange={handleMainFormChange}/>
                </div>
              }
                break
              case "material":
                  return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <select class="form-control" style={{ 'display': 'block', 'width': "256px" }} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                        {_.map(materials, opt => { return (
                          (opt == detailValue) ? (<option selected value={opt}>{opt}</option>) : (<option value={opt}>{opt}</option>)
                          )
                          })}
                      </select>
                    </div>
              case "select":
                  return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <select class="form-control" style={{ 'display': 'block', 'width': "256px" }} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                        {_.map(fieldname[3], opt => { return (
                          (opt == detailValue) ? (<option selected value={opt}>{opt}</option>) : (<option value={opt}>{opt}</option>)
                          )
                          })}
                      </select>
                    </div>
              case "operationtype_id":
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select class="form-control" style={{ 'display': 'block', 'width': "256px" }} name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange}>
                    {_.map(operationtypes, opt => { return (
                      (opt.id == detailValue) ? (<option selected value={opt.id}>{opt.name}</option>) : (<option value={opt.id}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
                case 'hours':
                    return (
                        <div style={{ float: 'left', width: '100%'}}>
                            {details?.hours && (
                                <HoursManagement
                                    ref={hoursRef}
                                    initialHoursData={details.hours}
                                    activeServices={details.active_services}
                                    availableServices={details.available_services}
                                    onHoursChange={handleHoursChange}
                                />
                            )}
                            <br style={{ clear: 'both' }} />
                        </div>
                    );
                case 'new_state':
                  return <div className="form-group" style={{ float: 'left', margin: '10px' }}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <select
                      className="form-control"
                      style={{ width: '256px' }}
                      name={fieldname[0]}
                      id={fieldname[0]}
                      value={detailValue ?? details.state ?? ''}
                      onChange={handleMainFormChange}
                    >
                      <option value="" disabled >Select action</option>
                      {/* Should we allow tenants to set ecosack back to free? */}
                      <option value={1} disabled >With Customer</option>
                      <option value={2}>Dropped Off</option>
                      <option value={3}>Processed</option>
                    </select>
                </div>
                case "tenant_site_id": {
                  const isReceiving = fieldname[0] === 'id_site_receiving';
                  const isProcessing = fieldname[0] === 'id_site_processing';
                  const state = String(details.new_state ?? details.state ?? '');

                  const isEnabled =
                    (isReceiving && (state === '2' || state === '3')) ||
                    (isProcessing && state === '3');

                  return <div className="form-group" style={{ float: 'left', margin: '10px' }}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <select
                      className="form-control"
                      style={{ width: '256px' }}
                      name={fieldname[0]}
                      id={fieldname[0]}
                      value={detailValue ?? ''}
                      onChange={handleMainFormChange}
                      disabled={!isEnabled}
                    >
                      <option value="" disabled>Select site</option>
                      {_.map(tenantSites, opt => (
                        <option key={opt.id} value={opt.id}>{opt.name}</option>
                      ))}
                    </select>
                  </div>
                }
              default:
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue={detailValue} onChange={handleMainFormChange} />
                </div>
            }

          })
        }
        {editable_fields.length > 0 &&
            <>
            <br style={{ 'clear': 'both' }} />
            <Button type='submit' style={{ 'margin': '10px', 'display': 'block', 'float': 'left' }}>Save</Button>
            <Typography
              id="details_status"
              variant="h6"
              component="h2"
              style={{ lineHeight: '36px', padding: '10px' }}
            >
              {status.kind === "loading" && "Saving..."}
              {status.kind === "success" && status.message}
              {status.kind === "error" && <span style={{ color: 'red' }}>ERROR: {status.message}</span>}
              {status.kind === "info" && status.message}
            </Typography>
            </>
        }
        {detail_delete_url !== undefined &&
            <Button
              type='button'
              onClick={handleDelete}
              style={{ 'margin': '10px', 'display': 'block', 'float': 'left', 'color': 'red' }}
            >
              Delete
            </Button>
        }
      </form>


      {(ledger_get_url !== undefined) &&
        <LedgerComponent rowData={rowData} ledger_get_url={ledger_get_url} ledger_allow_entries={ledger_allow_entries} />
      }

      <hr style={{ 'clear': 'both' }} />

      {(show_machine_stats === true) &&
        <>
          <Grid container>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography variant="body">Currently online:</Typography><br style={{ 'clear': 'both' }} />
                <span style={{ 'fontSize': '48px', 'fontWeight': 'bold' }}>{details['online']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography variant="body">#Containers counted:</Typography><br style={{ 'clear': 'both' }} />
                <span style={{ 'fontSize': '48px', 'fontWeight': 'bold' }}>{details['total_containers']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography variant="body">Runtime (s):</Typography> <br style={{ 'clear': 'both' }} />
                <span style={{ 'fontSize': '48px', 'fontWeight': 'bold' }}>{details['total_runtime_s']}</span>
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
              </Box>
            </Grid>
          </Grid>

          <hr />

          <Grid container>
            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography>CPU: {details['cpu_used_perc']}%</Typography>
                {/* <Progress progress={details['cpu_used_perc']} style={{ 'width': '50%', 'margin-left': 'auto', 'margin-right': 'auto' }} /> */}
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography>RAM: {details['ram_used_perc']}%</Typography>
                {/* <Progress progress={details['ram_used_perc']} style={{ 'width': '50%', 'margin-left': 'auto', 'margin-right': 'auto' }} /> */}
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography>HDD-1: {details['disk1_used_perc']}%</Typography>
                {/* <Progress progress={details['disk1_used_perc']} style={{ 'width': '50%', 'margin-left': 'auto', 'margin-right': 'auto' }} /> */}
              </Box>
            </Grid>

            <Grid item sm={6} md={3}>
              <Box textAlign='center'>
                <Typography>HDD-2: {details['disk2_used_perc']}%</Typography>
                {/* <Progress progress={details['disk2_used_perc']} style={{ 'width': '50%', 'margin-left': 'auto', 'margin-right': 'auto' }} /> */}
              </Box>
            </Grid>
          </Grid>
        </>

      }
    </>
  );
}

// handles button and modal overlay
const EditComponent = (props) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <td >
      <Button onClick={handleOpen} style={{ 'padding':'6px 16px' }}><EditIcon /></Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.detailsBox} style={{ 'maxHeight': '100vh', 'overflowY': 'auto' }}>

          <DetailsEditComponent
            {...props}
            onDeleted={handleClose}
          />
        </Box>
      </Modal>
    </td>
  );
};

export { DetailsEditComponent };
export default EditComponent;
